export const uk = {
    'set-context-price': 'Максимальная ставка за тыс. показов для новых и измененных условий показа'
};
